import React, { useState } from "react";
import ReactPlayer from "react-player";

const VideoPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const videoUrl = "https://www.youtube.com/watch?v=2XK4NVFnNHo";
 

  // Function to extract video ID from the YouTube URL
  const getThumbnailUrl = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return `https://img.youtube.com/vi/${videoId}/0.jpg`; // Fetch the first frame thumbnail
  };

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div style={{ position: "relative", width: "80%", maxWidth: "100%", margin: "0 auto" }}>
      {!isPlaying && (
        <div
          style={{
            position: "relative",
            width: "100%",
            paddingTop: "40.25%",
            backgroundImage: `url("${getThumbnailUrl(videoUrl)}")`, // Dynamically fetch the first frame thumbnail
            backgroundSize: "cover",
            backgroundPosition: "center",
            cursor: "pointer",
          }}
          onClick={handlePlayPause}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="48px"
              height="48px"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      )}

      {isPlaying && (
        <div style={{ position: "relative", paddingTop: "40.25%" }}>
          <ReactPlayer
            url={videoUrl}
            playing={isPlaying}
            controls
            width="100%"
            height="100%"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
            onPause={() => setIsPlaying(false)}
            onEnded={handleVideoEnd}
          />
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
